import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useReducer
} from 'react';
import {
  authReducer,
  initialAuthState
} from '@shared/context/reducers/AuthReducer';
import {loginUser, logoutUser} from '@shared/context/actions/AuthActions';
import {AuthModel} from '@shared/context/mappers/AuthTypesMapper';

interface AuthContextInterface {
  readonly authState: AuthModel;
  readonly logout: () => void;
  readonly login: (data: object) => void;
}

const AuthContext = createContext<AuthContextInterface>(
  {} as AuthContextInterface
);

export const useAuthContext = (): AuthContextInterface =>
  useContext(AuthContext);

export const AuthContextProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [authState, dispatch] = useReducer(authReducer, initialAuthState);

  const logout = (): void => {
    logoutUser(dispatch);
  };

  const login = (data: any): void => {
    loginUser(dispatch, data);
  };

  return (
    <AuthContext.Provider value={{authState, logout, login}}>
      {children}
    </AuthContext.Provider>
  );
};
